<template>
    <div class="examRecord">
        <div v-if="Mobile==false">
            <usertop></usertop>
            <div class="user_bread">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">考试任务</el-breadcrumb-item>
                    <el-breadcrumb-item>视频学习</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <video-player class="vjs-custom-skin" :options="playerOptions"></video-player>
            <div class="btn_up">
                <el-button type="info" style="padding:10px 30px;margin-right:100px;">ppt演示</el-button>
                <el-button type="primary" style="padding:10px 30px;">开始考试</el-button>
            </div>
        </div>
        <div v-else style="width:100%">
            <video-player class="vjs-custom-skin" :options="playerOptions"></video-player>
          
        </div>
    </div>
</template>
<script>
import usertop from './userTop'
    export default{
        name:'userknow', 
        data(){
            return{
               Mobile:false,
               playerOptions: {
                    playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: false, //如果true,浏览器准备好时开始回放。
                    controls: true, //控制条
                    preload: 'auto', //视频预加载
                    muted: false, //默认情况下将会消除任何音频。
                    loop: false, //导致视频一结束就重新开始。
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        type: 'video/mp4',
                        src: 'https://video.junchenlun.com/sv/a1c1fea-1708498deff/a1c1fea-1708498deff.mp4?auth_key=1593424747-0-0-9583a552db96ac88fc77c34acf977628'//你所放置的视频的地址，最好是放在服务器上
                    }],
                    width: document.documentElement.clientWidth,
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                }
            }
        },
        methods:{
            _isMobile(){
                 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	             return flag;
            }
        },
        components:{
            usertop,
        },
        created(){
            if(this._isMobile()){
                this.Mobile=true
            }
            else{
                this.Mobile=false
            }
        },
        mounted(){
            
        }
    }
</script>
<style>
    @import "../../assets/css/user.css";
    @import "../../assets/css/task.css";
</style>


// WEBPACK FOOTER //
// src/components/user/userVideo.vue